import { useMutation } from '@tanstack/react-query';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { Button, Text } from '@bonusly/design-system';
import { useHttpClient } from '@bonusly/http-client';
import { useIdentity } from '@bonusly/who-am-i';

interface UserFollowButtonProps {
	userId: string;
	isFollowing: boolean;
}
export const UserFollowButton: FC<UserFollowButtonProps> = ({ isFollowing, userId }) => {
	const { refetchProfile } = useIdentity();
	const http = useHttpClient();
	const { t } = useTranslation('components');
	const { mutate } = useMutation({
		mutationFn: async ({ userId, type }: any) => {
			await http.post(`/users/${userId}/${type}`);
			refetchProfile();
		},
	});

	const handleClick = () => {
		const type = isFollowing ? 'unfollow' : 'follow';
		mutate({ userId, type });
	};

	return (
		<Button size="xs" variant="alpha" borderRadius="md" onClick={handleClick}>
			<Text fontSize="sm" fontWeight="medium">
				{isFollowing ? t('user_popover.unfollow') : t('user_popover.follow')}
			</Text>
		</Button>
	);
};
